// extracted by mini-css-extract-plugin
export default {"base":"ReCaptcha_base__bCiXj"};